module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "headers": _vm.headers,
      "with-credentials": true,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": false,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "onProgress": _vm.onProgress,
      "showUploadList": false,
      "accept": _vm.accept,
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)]), _vm._v(" "), _c('ul', _vm._l((_vm.fileList), function(item, index) {
    return _c('li', [(item && ((!item.status) || (item.status && item.status === 'finished'))) ? [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v("   "), _c('a', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    }, [_vm._v("删除")])] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3503d28e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FileUpload.vue
// module id = 1747
// module chunks = 8